module.exports = __webpack_public_path__ + "img/0ad52c2.svg";